import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "coupon-mgmt" }
const _hoisted_2 = { class: "coupon-mgmt__header" }
const _hoisted_3 = { class: "coupon-mgmt__filters" }
const _hoisted_4 = { class: "cm-dialog" }
const _hoisted_5 = {
  key: 0,
  class: "cm-error"
}
const _hoisted_6 = { class: "cm-dialog-actions" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "cm-result"
}
const _hoisted_10 = { class: "cm-result-codes" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "cm-result-actions" }
const _hoisted_13 = { class: "cm-table" }
const _hoisted_14 = {
  key: 0,
  class: "cm-badge cm-badge--expired"
}
const _hoisted_15 = {
  key: 1,
  class: "cm-badge cm-badge--active"
}
const _hoisted_16 = {
  key: 2,
  class: "cm-badge cm-badge--disabled"
}
const _hoisted_17 = { class: "cm-actions" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "cm-pagination" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[17] || (_cache[17] = _createElementVNode("h2", null, "兑换码管理", -1)),
      _createElementVNode("button", {
        type: "button",
        class: "cm-btn cm-btn--primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateDialog = true))
      }, "创建兑换码")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
        placeholder: "搜索兑换码...",
        class: "cm-input",
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.debouncedSearch && _ctx.debouncedSearch(...args)))
      }, null, 544), [
        [_vModelText, _ctx.searchQuery]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statusFilter) = $event)),
        class: "cm-select",
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCoupons(1)))
      }, [...(_cache[18] || (_cache[18] = [
        _createElementVNode("option", { value: "" }, "全部状态", -1),
        _createElementVNode("option", { value: "enabled" }, "启用", -1),
        _createElementVNode("option", { value: "disabled" }, "禁用", -1),
        _createElementVNode("option", { value: "expired" }, "已过期", -1)
      ]))], 544), [
        [_vModelSelect, _ctx.statusFilter]
      ])
    ]),
    (_ctx.showCreateDialog)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cm-overlay",
          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.showCreateDialog = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[20] || (_cache[20] = _createElementVNode("h3", null, "批量创建兑换码", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("label", null, "面额（积分）", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.amount) = $event)),
              type: "number",
              min: "1",
              class: "cm-input"
            }, null, 512), [
              [
                _vModelText,
                _ctx.form.amount,
                void 0,
                { number: true }
              ]
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("label", null, "过期时间（可选）", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.expiresAt) = $event)),
              type: "datetime-local",
              class: "cm-input"
            }, null, 512), [
              [_vModelText, _ctx.form.expiresAt]
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "最大使用次数", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.maxUses) = $event)),
              type: "number",
              min: "1",
              class: "cm-input"
            }, null, 512), [
              [
                _vModelText,
                _ctx.form.maxUses,
                void 0,
                { number: true }
              ]
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("label", null, "备注", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.remark) = $event)),
              placeholder: "用途标签",
              class: "cm-input"
            }, null, 512), [
              [_vModelText, _ctx.form.remark]
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("label", null, "批量数量", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.count) = $event)),
              type: "number",
              min: "1",
              max: "1000",
              class: "cm-input"
            }, null, 512), [
              [
                _vModelText,
                _ctx.form.count,
                void 0,
                { number: true }
              ]
            ]),
            (_ctx.createError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.createError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "cm-btn",
                disabled: _ctx.creating,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showCreateDialog = false))
              }, "取消", 8, _hoisted_7),
              _createElementVNode("button", {
                type: "button",
                class: "cm-btn cm-btn--primary",
                disabled: _ctx.creating || !_ctx.form.amount,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.doCreate && _ctx.doCreate(...args)))
              }, _toDisplayString(_ctx.creating ? '创建中...' : '创建'), 9, _hoisted_8)
            ]),
            (_ctx.createdCoupons.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[19] || (_cache[19] = _createElementVNode("p", { class: "cm-result-hint" }, "兑换码仅在创建时展示一次，请立即复制保存", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdCoupons, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c.id,
                        class: "cm-result-code"
                      }, [
                        _createElementVNode("code", null, _toDisplayString(c.code), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "cm-btn cm-btn--small",
                          onClick: ($event: any) => (_ctx.copyText(c.code))
                        }, "复制", 8, _hoisted_11)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "cm-btn cm-btn--small",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.copyAllCodes && _ctx.copyAllCodes(...args)))
                    }, "复制全部"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "cm-btn cm-btn--primary cm-btn--small",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeCreateDialog && _ctx.closeCreateDialog(...args)))
                    }, "完成")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_13, [
      _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "兑换码"),
          _createElementVNode("th", null, "面额"),
          _createElementVNode("th", null, "已用/总次数"),
          _createElementVNode("th", null, "过期时间"),
          _createElementVNode("th", null, "备注"),
          _createElementVNode("th", null, "状态"),
          _createElementVNode("th", null, "操作")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupons, (c) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: c.id
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("code", null, _toDisplayString(c.code), 1)
            ]),
            _createElementVNode("td", null, _toDisplayString(c.amount), 1),
            _createElementVNode("td", null, _toDisplayString(c.usedCount) + "/" + _toDisplayString(c.maxUses), 1),
            _createElementVNode("td", null, _toDisplayString(c.expiresAt ? new Date(c.expiresAt).toLocaleString() : '永不过期'), 1),
            _createElementVNode("td", null, _toDisplayString(c.remark || '-'), 1),
            _createElementVNode("td", null, [
              (c.expired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "已过期"))
                : (c.enabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "启用"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, "禁用"))
            ]),
            _createElementVNode("td", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                class: "cm-btn cm-btn--small",
                onClick: ($event: any) => (_ctx.copyLink(c.code))
              }, "复制链接", 8, _hoisted_18),
              _createElementVNode("button", {
                type: "button",
                class: "cm-btn cm-btn--small",
                onClick: ($event: any) => (_ctx.doToggle(c))
              }, _toDisplayString(c.enabled ? '禁用' : '启用'), 9, _hoisted_19),
              _createElementVNode("button", {
                type: "button",
                class: "cm-btn cm-btn--small cm-btn--danger",
                onClick: ($event: any) => (_ctx.doDelete(c.id))
              }, _toDisplayString(_ctx.confirmDeleteId === c.id ? '确认删除？' : '删除'), 9, _hoisted_20)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        disabled: _ctx.page <= 1,
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadCoupons(_ctx.page - 1)))
      }, "上一页", 8, _hoisted_22),
      _createElementVNode("span", null, "第 " + _toDisplayString(_ctx.page) + " / " + _toDisplayString(_ctx.totalPages) + " 页", 1),
      _createElementVNode("button", {
        disabled: _ctx.page >= _ctx.totalPages,
        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadCoupons(_ctx.page + 1)))
      }, "下一页", 8, _hoisted_23)
    ])
  ]))
}